export class ProjectJobUpdateReq {
    id: string = ""
    name: string = ""
    description: string = ""
    formId: string = ""
    maxInput: number = 0
    placeId?: string = ""
    areaId?: string = ""
    projectName: string = ""
    type: number = 0
    instruction: string = ""
    additionalInfo: string = ""
    groupName: string = ""
    isRunning: boolean = false
    lockSubmitDistance: boolean = false
    webFormEligible: boolean = false
    requireAudioRecording: boolean = false
    editableLocation: boolean = false
}